export const menuDataResponse = {
  menus: [
    {
      id: "menu_seg_818d9c3e_90be_4081_8db5_d7dce5876829",
      title: "Hoja de vida",
      index: 9,
      breadCrumbText: "Hoja de vida",
      code: "HV",
      icon: "assignment_ind",
      url: "/hoja-vida",
      subMenus: null,
      order: 0,
    },
    {
      id: "menu_seg_818d9c3e_90be_4081_8db5_d7dce5876827",
      title: "Vacantes",
      index: 7,
      breadCrumbText: "Vacantes",
      code: "VAC",
      icon: "folder_open",
      url: "/vacancies",
      subMenus: null,
      order: 1,
    },
    {
      id: "menu_seg_818d9c3e_90be_4081_8db5_d7dce5876822",
      title: "Regionales",
      index: 2,
      breadCrumbText: "Regionales",
      code: "REG",
      icon: "location_city",
      url: "/regional",
      subMenus: null,
      order: 2,
    },
    {
      id: "menu_seg_818d9c3e_90be_4081_8db5_d7dce5876825",
      title: "Cargos",
      index: 4,
      icon: "badge",
      code: "CAR",
      c1Code: "PER_CAR",
      url: null,
      order: 3,
      subMenus: [
        {
          id: "menu_seg_818d9c3e_90be_4081_8db5_d7dce58768d45",
          title: "Cargos",
          code: "CAR",
          index: 5,
          breadCrumbText: "Cargos    |    Cargos ",
          icon: "badge",
          url: "/cargos",
          order: 4,
        },
        {
          id: "menu_seg_313d6c3e_90be_4081_8db5_d7dce58768d45",
          title: "Perfil de Cargos",
          code: "PER_CAR",
          index: 6,
          breadCrumbText: "Cargos   |   Cargos  >  Perfil de Cargos",
          icon: "badge",
          url: "/perfil-cargos",
          order: 5,
        },
      ],
    },
    {
      id: "menu_seg_818d9c3e_90be_4081_8db5_d7dce5876828",
      title: "Roles",
      index: 8,
      breadCrumbText: "Seguridad    |     Roles",
      code: "ROL",
      icon: "admin_panel_settings",
      url: "/rol",
      subMenus: null,
      order: 6,
    },
    {
      id: "menu_seg_818d9c3e_90be_4081_8db5_d7dce5876824",
      title: "Usuarios",
      index: 39,
      breadCrumbText: "Usuarios",
      code: "USU",
      icon: "manage_accounts",
      url: "/user",
      subMenus: null,
      order: 7,
    },
    {
      id: "menu_seg_818d9c3e_90be_4081_8db5_d7dce5876820",
      index: 1,
      breadCrumbText: "Requisición",
      code: "REQ",
      c1Code: "REQ_MANAGE",
      title: "Requisiciones",
      icon: "receipt_long",
      url: null,
      order: 8,
      subMenus: [
        {
          id: "menu_seg_878d9c2e_902be_4083_8db4_d7dce58768d01",
          title: "Ver Requisiciones",
          code: "REQ_VIEWER",
          index: 144,
          breadCrumbText: "Requisición    |    Ver requisiciones ",
          icon: "receipt_long",
          url: "/requisicion-view",
          order: 9,
        },
        {
          id: "menu_seg_818d9c3e_90be_4083_8db4_d7dce58768d01",
          title: "Tramitar Requisiciones",
          code: "REQ",
          index: 13,
          breadCrumbText: "Requisición    |    Tramitar requisiciones ",
          icon: "receipt_long",
          url: "/requisicion",
          order: 10,
        },
        {
          id: "menu_seg_818d9c3e_90be_4084_8db9_d7dce58768d02",
          title: "Gestionar Requisiciones",
          code: "REQ_MANAGE",
          index: 14,
          breadCrumbText: "Requisición   |   Gestionar requisiciones ",
          icon: "receipt_long",
          url: "/requisicion-gestionar",
          order: 11,
        },
        {
          id: "menu_seg_414d6c3e_90be_4081_8db5_d7dce5876827",
          title: "Gestionar Vacantes",
          index: 18,
          breadCrumbText: "Gestionar Vacantes",
          code: "VAC_PRIV",
          icon: "folder_open",
          url: "/gestion-vacancies",
          subMenus: null,
          order: 12,
        },
      ],
    },
    {
      id: "menu_seg_212d1c3e_90be_4081_8db5_d7dce5876820",
      index: 1,
      breadCrumbText: "Contratos",
      code: "CON",
      c1Code: "CON",
      title: "Contratos",
      icon: "grading",
      url: null,
      order: 13,
      subMenus: [
        {
          id: "menu_seg_818d9c3e_90be_4081_8db5_d7dce5876830",
          title: "Gestionar cláusulas",
          index: 10,
          breadCrumbText: "Gestionar cláusulas",
          code: "FOR_CLA_CON",
          icon: "list_alt",
          url: "/clauses-contracts",
          subMenus: null,
          order: 14,
        },
        {
          id: "menu_seg_818d9c3e_90be_4081_8db5_d7dce5876832",
          title: "Tipos de contratos",
          index: 11,
          breadCrumbText: "Tipos de contratos",
          code: "FOR_TIP_CON",
          icon: "admin_panel_settings",
          url: "/type-contracts",
          subMenus: null,
          order: 15,
        },
        {
          id: "menu_seg_818d9c3e_90be_4081_8db5_d9dce5876842",
          title: "Gestionar contratos",
          index: 17,
          breadCrumbText: "Gestionar contratos",
          code: "CON",
          icon: "grading",
          url: "/contracts",
          subMenus: null,
          order: 16,
        },
      ],
    },
    {
      id: "menu_seg_919d7c3e_72be_4081_8db5_d9dze5894269",
      title: "Gestión de empleados",
      index: 42,
      breadCrumbText: "Gestión de empleados",
      code: "CON",
      icon: "playlist_add",
      url: "/work-certificate-search",
      subMenus: null,
      order: 17,
    },
    {
      id: "menu_seg_111d2c1e_80be_4081_8db5_d7dce5876820",
      index: 1,
      breadCrumbText: "Permisos",
      code: "PERM",
      c1Code: "PERM",
      title: "Permisos",
      icon: "receipt",
      url: null,
      order: 18,
      subMenus: [
        {
          id: "menu_seg_818d9c3e_90be_4081_8db5_d9dce5843853",
          title: "Mis Permisos",
          index: 27,
          breadCrumbText: "Mis Permisos",
          code: "PERM",
          icon: "receipt",
          url: "/permissionsSearch/c3ee84b698ab7c8b1c8161180fc644c3cad1cd9b",
          subMenus: null,
          order: 19,
        },
        {
          id: "menu_seg_818d9c3e_90be_4081_8db5_d9dce5876853",
          title: "Tramitar Permisos",
          index: 28,
          breadCrumbText: "Tramitar Permisos",
          code: "PERM",
          icon: "receipt",
          url: "/permissionsSearch/ca76a54021477153361f25b6ec3fb42378a8638c",
          subMenus: null,
          order: 20,
        },
        {
          id: "menu_seg_818d9c3e_90be_4081_8db5_d9dze5876853",
          title: "Gestionar Permisos",
          index: 21,
          breadCrumbText: "Gestionar Permisos",
          code: "PERM_MANAGE",
          icon: "receipt",
          url: "/permissionsSearch/51bd95353aeda6615433bea21896c893ef5e62dc",
          subMenus: null,
          order: 21,
        },
      ],
    },
    {
      id: "menu_seg_818d9c3e_90be_4971_8db5_d7dce5876820",
      index: 1,
      breadCrumbText: "Exámenes médicos",
      code: "EXAM_MED",
      c1Code: "EXAM_MED",
      title: "Exámenes médicos",
      icon: "medical_services",
      url: null,
      order: 22,
      subMenus: [
        {
          id: "menu_seg_818d9c3e_90be_4081_8db5_d9dze5876855",
          title: "Laboratorio",
          index: 22,
          breadCrumbText: "Laboratorio",
          code: "LAB",
          icon: "science",
          url: "/laboratory",
          subMenus: null,
          order: 23,
        },
        {
          id: "menu_seg_818d9c3e_90be_4081_8db5_d9dze5876455",
          title: "Consultar orden exámenes médicos",
          index: 23,
          breadCrumbText: "Consultar orden exámenes médicos",
          code: "EXAM_MED",
          icon: "medical_services ",
          url: "/medicalExams",
          subMenus: null,
          order: 24,
        },

        {
          id: "menu_seg_818d9c3e_90be_4081_8db5_d9dze5876956",
          title: "Consultar orden de servicio colectivo",
          index: 25,
          breadCrumbText: "Consultar orden de servicio colectivo",
          code: "SER_COL",
          icon: "medical_services ",
          url: "/collective-service-order",
          subMenus: null,
          order: 25,
        },
      ],
    },
    {
      id: "menu_seg_818d0c3e_99be_4981_8db5_d9dze5896955",
      title: "Consultar registro de embarazos",
      index: 30,
      breadCrumbText: "Consultar registro de embarazos",
      code: "MAT_LIC",
      icon: "pregnant_woman",
      url: "/pregnant",
      subMenus: null,
      order: 26,
    },
    {
      id: "menu_seg_818d9c3e_90be_4081_8db5_d9dze5896966",
      title: "Entrega de dotación",
      index: 31,
      breadCrumbText: "Entrega de dotación",
      code: "DOT",
      icon: "assignment_turned_in",
      url: "/endowment-delivery",
      subMenus: null,
      order: 27,
    },
    {
      id: "menu_seg_871d9c3e_29be_4081_6db5_d7dze5896966",
      title: "Entrega de dotación",
      index: 32,
      breadCrumbText: "Entrega de dotación",
    },
    {
      id: "menu_seg_919d7c3e_72be_4081_8db5_d9dze5894266",
      title: "Reintegro por recomendaciones AT",
      index: 41,
      breadCrumbText: "Reintegro por recomendaciones AT",
      code: "REF_REC",
      icon: "rotate_left",
      url: "/refund-recomendation-search",
      subMenus: null,
      order: 28,
    },
    {
      id: "menu_seg_818d9c3e_69be_4081_8db5_d9dze5893266",
      title: "Reintegro por recomendaciones AT",
      index: 40,
      breadCrumbText: "Reintegro por recomendaciones AT",
    },
    {
      id: "menu_seg_818d9c3e_90be_4081_8db5_d9ze58769847",
      title: "Autoevaluaciones",
      index: 26,
      breadCrumbText: "Autoevaluaciones",
      code: "AUT",
      icon: "autoeval",
      url: "https://g-pull-front-dot-sae-dev.appspot.com/auth/login",
      subMenus: null,
      order: 29,
    },
    {
      id: "menu_seg_818d9c3e_90be_4081_8db5_d7dce5876831",
      title: "Iniciar Proceso",
      index: 12,
      breadCrumbText: "Iniciar Proceso",
      code: "INI_PROC",
      icon: "admin_panel_settings",
      url: "/start-process",
      subMenus: null,
      order: 30,
    },
    {
      id: "menu_seg_818d9c3e_90be_4081_8db5_d7dce5876840",
      title: "Configuración de la cuenta",
      index: 15,
      breadCrumbText: "Configuración de la cuenta",
      code: "USER_CONFIG",
      icon: "admin_panel_settings",
      url: "/configuration",
      subMenus: null,
      order: 31,
    },
    {
      id: "menu_seg_919d7c3e_72be_4181_9db5_d7dze5894269",
      title: "Postulados",
      index: 51,
      breadCrumbText: "Postulados",
    },
  ],
};
